import React from 'react';
import { Switch, Route, Redirect } from 'react-router';

import AuthOrApp from './authOrApp'
import Dashboard from '../dashboard/dashboard';
import UsuarioPerfil from '../usuarioPerfil/usuarioPerfil';
import Usuario from '../usuario/usuario';
import Hospital from '../hospital/hospital';
import Radiologista from '../radiologista/radiologista';
import Exame from '../exame/exame';
import GrupoFaturamento from '../grupoFaturamento/grupoFaturamento';
import GrupoFaturamentoRadiologista from '../grupoFaturamentoRadiologista/grupoFaturamentoRadiologista';
import HospitalConvenio from '../hospitalConvenio/hospitalConvenio';
import Contrato from '../contrato/contrato';
import LaudoImportacao from '../laudoImportacao/laudoImportacao';
import RelatorioRadiologistaSintetico from '../relatorioRadiologistaSintetico/relatorioRadiologistaSintetico';
import RelatorioRadiologistaAnalitico from '../relatorioRadiologistaAnalitico/relatorioRadiologistaAnalitico';
import RelatorioHospital from '../relatorioHospital/relatorioHospital';

export default props => (
	<div id='id-content-wrapper' className='content-wrapper' >
		<Switch>
			<Route exact path='/' component={Dashboard} />
			<Route path='/usuarioPerfil' component={UsuarioPerfil} />
			<Route path='/usuario' component={Usuario} />
			<Route path='/hospital' component={Hospital} />
			<Route path='/radiologista' component={Radiologista} />
			<Route path='/exame' component={Exame} />
			<Route path='/grupoFaturamento' component={GrupoFaturamento} />
			<Route path='/grupoFaturamentoRadiologista' component={GrupoFaturamentoRadiologista} />
			<Route path='/hospitalConvenio' component={HospitalConvenio} />
			<Route path='/contrato' component={Contrato} />
			<Route path='/laudoImportacao' component={LaudoImportacao} />
			<Route path='/relatorioRadiologistaSintetico' component={RelatorioRadiologistaSintetico} />
			<Route path='/relatorioRadiologistaAnalitico' component={RelatorioRadiologistaAnalitico} />
			<Route path='/relatorioHospital' component={RelatorioHospital} />
			<Redirect from='*' to='/' />
		</Switch>
	</div>
);
